import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
      }}
    >
      <p style={{ fontSize: 32, marginBottom: 20 }}>未找到该页面</p>
      <Button onClick={() => navigate("/")}>点击回到首页</Button>
    </div>
  );
};

export default NotFound;
